import React from 'react';
import BrowsingCriteriaBlock from "../BrowsingCriteriaBlock";








var BcActionBlock = function BcActionBlock(_ref)




{var actionButton = _ref.actionButton,browsingShortName = _ref.browsingShortName,styles = _ref.styles,bcWidth = _ref.bcWidth;
  return /*#__PURE__*/(
    React.createElement("div", { className: styles },
    browsingShortName && /*#__PURE__*/
    React.createElement(BrowsingCriteriaBlock, { shortName: browsingShortName, bcWidth: bcWidth }),

    actionButton && actionButton));


};

export default BcActionBlock;
//# sourceMappingURL=index.js.map